import { render, staticRenderFns } from "./MainHeaderWeatherStatus.vue?vue&type=template&id=ef620dd6"
import script from "./MainHeaderWeatherStatus.vue?vue&type=script&lang=js"
export * from "./MainHeaderWeatherStatus.vue?vue&type=script&lang=js"
import "./MainHeaderWeatherStatus.vue?vue&type=style&index=0&id=ef620dd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports